import { Copy } from "lucide-mui";
import IconButton, { type IconButtonProps } from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { copyToClipboard } from "../utils/clipboard.ts";

interface CopyButtonProps {
  text: string;
  /** Tooltip and accessible name. */
  label?: string;
  /** Toast shown after copying; without one the tooltip says "Copied!". */
  successMessage?: string;
  size?: IconButtonProps["size"];
  sx?: IconButtonProps["sx"];
}

export default function CopyButton({
  text,
  label = "Copy",
  successMessage,
  size = "small",
  sx,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <Tooltip title={copied ? "Copied!" : label}>
      <IconButton
        aria-label={label}
        size={size}
        sx={sx}
        onClick={async () => setCopied(await copyToClipboard(text, successMessage))}
      >
        <Copy fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
